import { Component } from '@angular/core';
import { ErrorHandlerService } from '../../services/error-handler.service';

@Component({
  selector: 'app-error-handler',
  templateUrl: './error-handler.component.html',
  styleUrl: './error-handler.component.css'
})
export class ErrorHandlerComponent {

  errorMessage: string[] = [];
  constructor(private errorService: ErrorHandlerService) { }
  ngOnInit(): void {
    this.errorService.getErrorMessage().subscribe((errors: string[]) => {
      if (errors && errors.length > 0) {
      this.errorMessage = errors;
      } else {
      this.errorMessage = []
      }
    });
  }

}
